<script setup lang="ts">
import CmsDataProvider, { CMS_DATA_ID } from "@/providers/cms.provider";

const cmsData = CmsDataProvider.get<{
    ctaButtonColor?: string,
    ctaButtonTextColor?: string
    ctaButtonHoverColor?: string
    headerBackgroundColor?: string
    headerFontColor?: string
}>(CMS_DATA_ID.ACTIVITEITEN_WIDGET);

</script>
<template>

    <component :is="'style'">
        :root {
        <template v-if="cmsData.ctaButtonColor">
            --sportmatch-widget-cta-button-color: {{ cmsData.ctaButtonColor }};
        </template>

        <template v-if="cmsData.ctaButtonTextColor">
            --sportmatch-widget-cta-button-text-color: {{ cmsData.ctaButtonTextColor }};
        </template>

        <template v-if="cmsData.ctaButtonHoverColor">
            --sportmatch-widget-cta-button-hover-color: {{ cmsData.ctaButtonHoverColor }};
        </template>

        <template v-if="cmsData.headerBackgroundColor">
            --sportmatch-widget-header-background-color: {{ cmsData.headerBackgroundColor }};
        </template>

        <template v-if="cmsData.headerFontColor">
            --sportmatch-widget-header-font-color: {{ cmsData.headerFontColor }};
        </template>
        }
    </component>
</template>